"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgBookmarkCircleSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm2.7 7.102H9.3a.84.84 0 00-.637.281.964.964 0 00-.263.683v9.322l3.6-2.25 3.6 2.25V8.066a.966.966 0 00-.262-.683.84.84 0 00-.638-.281z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgBookmarkCircleSolid;
exports.default = _default;